{
  "AgentOmnichannel_AllowAnsweringConcurrent": "Permitir responder a canais simultâneos:",
  "AgentOmnichannel_Chat_IntegrationType": "Chat Tipo de integração:",
  "AgentOmnichannel_Chat_IDOnChatSystem": "ID no sistema de chat:",
  "AgentOmnichannel_Chat_LiveChatAgentID": "ID do agente Livechat:",
  "AgentOmnichannel_Email_IntegrationType": "Tipo de integração de correio eletrónico:",
  "AgentOmnichannel_Email_EmailAddress": "Endereço de correio eletrónico:",
  "AgentOmnichannel_Email_IDOnEmailSystem": "ID no sistema de correio eletrónico:",
  "AgentOmnichannel_Chat_IntegrationTypes_None": "[Nenhum]",
  "AgentOmnichannel_Chat_IntegrationTypes_LiveChat": "LiveChat",
  "AgentOmnichannel_Email_IntegrationTypes_None": "[Nenhum]",
  "AgentOmnichannel_Email_IntegrationTypes_Pop3": "Correio eletrónico (POP3 e SMTP)",
  "AgentOmnichannel_Email_EmailAddress_Invalid": "O endereço de correio eletrónico é inválido",
  "NAME": "AgentOmnichannel"
}